import React from 'react';
import { Modal, Button, Typography } from 'antd';

const { Title } = Typography;
type TMentoringRuleModalProps = {
  visible: boolean;
  setVisible: any;
};
const MentoringRuleModal = ({ visible, setVisible }: TMentoringRuleModalProps) => {
  function handleCancel() {
    setVisible(false);
  }

  return (
    <Modal
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      footer={<Button onClick={handleCancel}>닫기</Button>}
      width={500}
      onCancel={handleCancel}
    >
      <div style={{ color: '#000' }}>
        <Title level={4}>취소 및 일정변경 규약</Title>
        <div style={{ color: '#000', fontSize: '14px' }}>
          <div>• 수업 시작 24시간 이전 : 취소 및 변경 가능 (CREDIT 환급)</div>
          <div>• 수업 시작 24시간 이내 : 취소 및 변경 불가 (CREDIT 차감)</div>
        </div>
      </div>
    </Modal>
  );
};

MentoringRuleModal.defaultProps = {};

export default MentoringRuleModal;
